export const Truncate = (name, maxLength) => {
    if (name.length <= maxLength) return name; // Return full name if it fits within the max length
  
    const words = name.split(" ");
    let truncated = "";
  
    for (let word of words) {
      if ((truncated + word).length <= maxLength) {
        truncated += word + " ";
      } else {
        break; // Stop adding words when max length is reached
      }
    }
  
    return truncated.trim() + "..."; // Trim to remove any extra spaces and add ellipsis
  };